"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const types_1 = require("@pbl/pbl-react-core/lib/models/survey/types");
const classnames_1 = require("classnames");
const _ = require("lodash");
const React = require("react");
const YoullEarnMsg_1 = require("../bonus-points/YoullEarnMsg");
const config_1 = require("../config/config");
const SurveyScreenStyle_1 = require("./jss/SurveyScreenStyle");
const MultiSelectQuestion_1 = require("./MultiSelectQuestion");
const SingleSelectQuestion_1 = require("./SingleSelectQuestion");
const TextQuestion_1 = require("./TextQuestion");
class UserSurvey extends React.Component {
    constructor() {
        super(...arguments);
        this.setResponse = (answer) => {
            this.props.onChange(answer);
        };
        this.onTextQuestionChange = (question, value) => {
            this.setResponse({ id: question.id, value });
        };
        this.onSingleSelectQuestionChange = (question, value) => {
            if (value)
                this.setResponse({ id: question.id, value: value.value });
        };
        this.onMultiSelectQuestionChange = (question, value) => {
            if (value) {
                this.setResponse({
                    id: question.id,
                    value: value.map(x => x.value).join('|')
                });
            }
        };
        this.onSave = () => {
            if (this.isValid()) {
                this.props.onSave();
            }
        };
        this.getQuestionLayoutFromExtraData = (questionIndex, questionLayout) => {
            try {
                if (!!questionLayout && questionIndex >= 0) {
                    const obj = JSON.parse(questionLayout);
                    if (!!obj) {
                        return obj[questionIndex + 1];
                    }
                }
            }
            catch (e) {
                return undefined;
            }
        };
        this.getQuestion = (question, index) => {
            const { surveyPostResponse, questionLayout, imageSurveyLayout } = this.props;
            let layout;
            let questionIndex;
            if (!!questionLayout) {
                questionIndex = _.findIndex(this.props.survey.questions, { id: question.id });
                layout = this.getQuestionLayoutFromExtraData(questionIndex, questionLayout);
            }
            switch (question.input_type_id) {
                case types_1.SurveyQuestionType.SingleSelect:
                    return ((0, jsx_runtime_1.jsx)(SingleSelectQuestion_1.default, { questionIndex: index, groupName: question.id, onChange: this.onSingleSelectQuestionChange, question: question, layout: layout, answer: surveyPostResponse.responses.find(x => x.id === question.id), imageSurveyLayout: !!imageSurveyLayout ? imageSurveyLayout : 'grid' }, question.id));
                case types_1.SurveyQuestionType.MultiSelect:
                    return ((0, jsx_runtime_1.jsx)(MultiSelectQuestion_1.default, { questionIndex: index, onChange: this.onMultiSelectQuestionChange, question: question, surveyOptions: this.findMultiResponse(question, surveyPostResponse), imageSurveyLayout: !!imageSurveyLayout ? imageSurveyLayout : 'grid' }, question.id));
                case types_1.SurveyQuestionType.Text:
                    return ((0, jsx_runtime_1.jsx)(TextQuestion_1.default, { questionIndex: index, onChange: this.onTextQuestionChange, question: question, answer: surveyPostResponse.responses.find(x => x.id === question.id) }, question.id));
                default:
                    return null;
            }
        };
        this.getQuestions = () => {
            const { questions } = this.props.survey;
            return questions.map((question, index) => {
                return this.getQuestion(question, index);
            });
        };
    }
    isValid() {
        const { survey, surveyPostResponse } = this.props;
        let isValid = true;
        if (surveyPostResponse === null ||
            surveyPostResponse.responses === null ||
            surveyPostResponse.responses.filter(x => x.value && x.value.length > 0).length < survey.questions.filter(x => !x.can_skip).length) {
            isValid = false;
        }
        else {
            survey.questions
                .filter(x => !x.can_skip)
                .forEach(question => {
                const responses = surveyPostResponse.responses.filter(x => x.id === question.id);
                if (responses.length > 0) {
                    const response = responses[0];
                    if (!response.value || response.value.length < 1) {
                        isValid = false;
                    }
                }
                else {
                    isValid = false;
                }
            });
        }
        return isValid;
    }
    findMultiResponse(question, surveyPostResponse) {
        const answer = surveyPostResponse ? surveyPostResponse.responses.find(x => x.id === question.id) : null;
        if (answer && answer.value) {
            const tokens = answer.value.split('|');
            return question.options.filter(option => tokens.find(item => item === option.value)) || null;
        }
        return [];
    }
    render() {
        const { isLoading, isSystemSurvey } = this.props;
        const { survey: { num_points }, classes } = this.props;
        return ((0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ container: true, spacing: 3, direction: "column" }, { children: [(0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, container: true, xs: 12, style: { flex: '1 1 auto' } }, { children: this.getQuestions() })), !this.isValid() && !isSystemSurvey ? ((0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "h5", component: 'span', gutterBottom: true, className: classes.surveyAnswer }, { children: 'Answer all questions above' }))) : null, (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ disabled: this.props.showSignInWarning || this.props.limitReached || !this.isValid() || isLoading, size: "large", variant: "contained", color: config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: this.onSave, "aria-label": !isSystemSurvey ? 'Submit' : 'Save', className: (0, classnames_1.default)(classes.surveyBtn, 'containedButton') }, { children: !isSystemSurvey ? 'Submit' : 'Save' })), !isSystemSurvey ? ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, style: { display: 'flex', justifyContent: 'center' } }, { children: (0, jsx_runtime_1.jsx)(YoullEarnMsg_1.default, { bonusPoints: this.props.bonusPoints, noneBonusPoints: num_points }) }))) : null] })));
    }
}
exports.default = (0, core_1.withTheme)((0, core_1.withStyles)(SurveyScreenStyle_1.default)(UserSurvey));
//# sourceMappingURL=UserSurvey.js.map